import React from 'react';
import cn from 'classnames';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { setBackUrl } from 'shared/lib/backUrl';
import { Submit, Button } from 'shared/components/Form';
import CloseButton from 'shared/components/buttons/Close';
import Tip from 'shared/components/Tip';
import { userportal as routes } from 'shared/routes';
import styles from './AccountRequiredModal.module.scss';

const AccountRequiredModal = ({ isOpen, toggle }) => {
  const { t } = useTranslation('userportal');
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginClick = () => {
    setBackUrl(location);
    navigate(routes.loginAsUser);
  };

  const handleSignupClick = () => {
    setBackUrl(location);
    navigate(routes.signupAsUser);
  };

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        toggle={toggle}
        close={<CloseButton onClick={toggle}>{t('common:linkButton.close')}</CloseButton>}
        className={styles.header}
      >
        <span className={styles.titleIcon}>🔐</span><span>{t('job.accountRequired.title')}</span>
      </ModalHeader>
      <ModalBody>
        <Tip className="mb16">{t('job.accountRequired.hint')}</Tip>
        <div className={cn(styles.body, 'row')}>
          <div className={cn('col-xl-7 col-lg-6 col-md-12 col-sm-12 col-xs-12', styles.left)}>
            <h3>{t('job.accountRequired.why')}</h3>
            <div className={styles.tile}>
              <span><i className="la la-list-alt" /></span>
              <p>
                <Trans i18nKey="userportal:job.accountRequired.tile.1">
                  <strong />
                </Trans>
              </p>
            </div>

            <div className={styles.tile}>
              <span><i className="la la-user-shield" /></span>
              <p>
                <Trans i18nKey="userportal:job.accountRequired.tile.2">
                  <strong />
                </Trans>
              </p>
            </div>

            <div className={styles.tile}>
              <span><i className="la la-rocket" /></span>
              <p>
                <Trans i18nKey="userportal:job.accountRequired.tile.3" values={{ year: new Date().getFullYear() }}>
                  <strong />
                </Trans>
              </p>
            </div>

            <div className={styles.tile}>
              <span><i className="la la-bell" /></span>
              <p>
                <Trans i18nKey="userportal:job.accountRequired.tile.4">
                  <strong />
                </Trans>
              </p>
            </div>

            <div className={styles.tile}>
              <span><i className="la la-brain" /></span>
              <p>
                <Trans i18nKey="userportal:job.accountRequired.tile.5">
                  <strong />
                </Trans>
              </p>
            </div>
          </div>
          <div className={cn('col-xl-5 col-lg-6 col-md-12 col-sm-12 col-xs-12', styles.right)}>
            <h3>{t('job.accountRequired.loginSignup')}</h3>
            <div>
              <Submit fullWidth iconClassName="la la-sign-in-alt" title={t('job.accountRequired.login')} onClick={handleLoginClick} />
              <Button fullWidth iconClassName="la la-user-plus" title={t('job.accountRequired.signup')} onClick={handleSignupClick} />

              <p className="text-center">
                {t('job.accountRequired.signupHint')}
              </p>
            </div>
            <hr />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AccountRequiredModal;
